
import "./notfound.page.css";

function NotFound() {

    return (
        <div id="not-found" className="standard-page">
            <h5 className="mt-5">404 - Seite nicht gefunden :/</h5>
        </div>
    );
}

export default NotFound;